import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { PaymentScenarionActionMethodEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.action.method.enum';
import { PaymentScenarionActionMethodEnumI18n } from '@zaoblako/shared/modules/task/i18n/payment-scenarion-action-method.enum.i18n';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';

import * as yup from 'yup';

/** Payment scenarion action response body */
export interface PaymentScenarionActionFormInterface {
  /** Unique identifier */
  id?: number;
  /** Action kind - method of interaction */
  method: PaymentScenarionActionMethodEnum;
  /** Approvers, to be added to the scheme */
  approvers?: UserFindInterface[];
}

/** Payment scenarion action DTO */
export const PaymentScenarionActionFormDto = SerdeDtoClass.create<PaymentScenarionActionFormInterface>(
  TaskDtoKeysEnum.PAYMENT_SCENARION_ACTION_FORM_DTO,
  {
    id: {
      optional: true,
      label: 'Номер',
      serializer: yup.number(),
    },
    method: {
      label: 'Способ',
      serializer: commonEnumValidator(PaymentScenarionActionMethodEnum, PaymentScenarionActionMethodEnumI18n),
    },
    approvers: {
      optional: true,
      label: 'Согласователи',
      serializer: yup.array(entityLikeSchema),
    },
  },
);
